import { Component, EventEmitter, OnDestroy, OnInit, Output, ChangeDetectorRef, ChangeDetectionStrategy, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GtwSnackbarService } from '../../../shared/_services/gtw-snackbar.service';
import { F1120SchJService } from './f1120-sch-j.service';
import * as _ from 'lodash-es';
import { Subscription } from 'rxjs';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { AppService } from '../../../app.service';
import {
  buildHeaderDataShell,
  normalizeFilterParams,
  rowPayloadFromActiveScreen,
  hydratedGlobalParams,
} from '../../../shared/workspace-element-context';

@Component({
    selector: 'gtw-f1120-sch-j',
    templateUrl: './f1120-sch-j.component.html',
    styleUrls: ['./f1120-sch-j.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class F1120SchJComponent implements OnInit, OnDestroy {
  private readonly destroyRef = inject(DestroyRef);

  private readonly subs = new Subscription();

  @Output('request-grid-update') requestGridUpdate = new EventEmitter<any>();

  globalService: any;
  filterParams: any = {};
  GENERAL_CONFIG: any;
  rowData: any = {};

  currentTabName = "Form Entry";
  minimise = false;
  isSaveClicked = false;
  
  modalTitle = "F1120 - Schedule J - Line 5a - Foreign Tax Credit (attach Form 1118)";
  loading = false;
  crudLoading = false;
  disable = true;
  dataLoaded = false;
  
  modalData: any[] = [];

  constructor(
    private f1120SchJService: F1120SchJService,
    private _snackBar: MatSnackBar, private gtwSnackbar: GtwSnackbarService,
    private cdr: ChangeDetectorRef,
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService
  ) {}

  ngOnInit(): void {
    this.applyWorkspaceContext();
    this.subs.add(this.gtwWorkspace.setTabActive.subscribe(() => {
      this.applyWorkspaceContext();
      this.init();
    }));
    this.subs.add(this.gtwGlobal.globalParamsChanged$.subscribe(() => {
      this.applyWorkspaceContext();
      this.init();
    }));
    this.init();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    const header = buildHeaderDataShell(this.gtwGlobal, this.gtwApp);
    header.globalParams = hydratedGlobalParams(this.gtwGlobal, this.gtwWorkspace) || header.globalParams || {};
    this.GENERAL_CONFIG = header.generalConfigData || {};
    this.globalService = header;
    this.filterParams = normalizeFilterParams(activeScreen);
    this.rowData = rowPayloadFromActiveScreen(activeScreen);
    this.globalService.filterParams = this.filterParams;
    this.dataLoaded = false;
    this.cdr.markForCheck();
  }

  init() {
    try {
      if (this.globalService && Object.keys(this.filterParams).length > 0 && !this.dataLoaded) {
        this.getModalData();
        this.dataLoaded = true;
      }
    } catch (e) {
      console.error('Error in component init:', e);
    }
  }

  getModalData() {
    this.loading = true;
    
    console.log('🔧 F1120SchJ - Loading modal data');

    this.f1120SchJService.getScheduleJData(
      this.GENERAL_CONFIG.base_url,
      this.globalService,
      this.filterParams
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        console.log('🔧 F1120SchJ - Received data:', response);
        
        if (response && response.jsonObject) {
          this.modalData = response.jsonObject;
          
          if (this.modalData && this.modalData.length > 0) {
            console.log('🔧 F1120SchJ - Modal data loaded:', this.modalData);
          } else {
            this.gtwSnackbar.openSnackBar('No data found!', 'gtw-snackbar--red', true, 4);
          }
        } else {
          console.error('🔧 F1120SchJ - Invalid response structure:', response);
          this.gtwSnackbar.openSnackBar('Invalid data structure received from server.', 'gtw-snackbar--red', true, 4);
        }
        
        this.loading = false;
        this.cdr.markForCheck();
      },
      (error: any) => {
        console.error('🔧 F1120SchJ - Error loading modal data:', error);
        this.loading = false;
        this.gtwSnackbar.openSnackBar('Error loading data. Please try again.', 'gtw-snackbar--red', true, 4);
        this.cdr.markForCheck();
      }
    );
  }

  valuechanged() {
    this.disable = false;
  }

  checkbox(index: number) {
    if (index == 1 && this.modalData[index].CHECKBOX_VALUE == 'Y') {
      this.modalData[0].CHECKBOX_VALUE = 'N';
    } else if (index == 0 && this.modalData[index].CHECKBOX_VALUE == 'Y') {
      this.modalData[1].CHECKBOX_VALUE = 'N';
    }
    
    this.modalData = _.cloneDeep(this.modalData);
    this.disable = false;
  }

  save() {
    this.isSaveClicked = true;
    this.crudLoading = true;
    
    const message = "Form Details are successfully updated.";

    console.log('🔧 F1120SchJ - Saving modal data');

    this.f1120SchJService.saveScheduleJData(
      this.GENERAL_CONFIG.base_url,
      this.modalData,
      this.globalService,
      this.filterParams
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        console.log('🔧 F1120SchJ - Save response:', response);
        
        this.isSaveClicked = false;
        this.crudLoading = false;
        
        if (response.data && response.data.errorMessage != 'null') {
          console.log("There was the error message and the message is ", response.data.errorMessage);
          this.gtwSnackbar.openSnackBar(response.data.errorMessage, 'gtw-snackbar--red', true, 4);
        } else {
          console.log("There was no error message and the message was ", response.data?.errorMessage);
          this.gtwSnackbar.openSnackBar(message, 'gtw-snackbar--green', true, 4);
          
          this.requestGridUpdate.emit('refresh');
        }
        this.cdr.markForCheck();
      },
      (error: any) => {
        console.error('🔧 F1120SchJ - Save error:', error);
        
        this.isSaveClicked = false;
        this.crudLoading = false;
        
        this.gtwSnackbar.openSnackBar('Error saving data. Please try again.', 'gtw-snackbar--red', true, 4);
        this.cdr.markForCheck();
      }
    );
  }

  cancel() {
    this.requestGridUpdate.emit('cancel');
  }

  reset() {
    this.getModalData();
  }
}
